export default __webpack_public_path__ + "static/media/pascal.c033ba6d.gif";